import React, { useState, useEffect, useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"

import { getClientEmailTemplates } from "../../../state/clientEmailsSlice"
import EmailTemplate from "./EmailTemplate"
import { Link } from "react-router-dom"

const EmailCustomization = ()=>{

    let dispatch = useDispatch();

    let welcomeEmailBody = useSelector(state => state.clientEmails.welcomeEmail.email_body)

    useEffect(() => {
        dispatch(getClientEmailTemplates({email_type_id:"1"}))
    }, [])


    return (
    	<EmailTemplate 
    		isLoadingEmamil={useState(true)} 
    		emailBody={welcomeEmailBody}
    	/>
    )
}

export default EmailCustomization